export type FarmLike<Unit extends ProductionUnitLike = ProductionUnitLike> = {
  id?: string | null
  name?: string | null
  productionUnits?: Unit[] | null
}

export type ProductionUnitLike = {
  id?: string | null
  name?: string | null
}

const normalizeToken = (value: string | null | undefined): string => (value ?? '').toString().trim()

export const findFarmByIdOrName = <T extends FarmLike>(farms: T[], token: string | null | undefined): T | undefined => {
  const normalized = normalizeToken(token)
  if (!normalized) return undefined
  return farms.find((farm) => String(farm.id ?? '') === normalized)
    ?? farms.find((farm) => String(farm.name ?? '') === normalized)
}

export const findProductionUnitByIdOrName = <T extends ProductionUnitLike>(
  farm: FarmLike<T> | undefined,
  token: string | null | undefined
): T | undefined => {
  const normalized = normalizeToken(token)
  if (!farm || !normalized) return undefined
  const units = Array.isArray(farm.productionUnits) ? farm.productionUnits : []
  return units.find((unit) => String(unit.id ?? '') === normalized)
    ?? units.find((unit) => String(unit.name ?? '') === normalized)
}

export const resolveFarmId = <T extends FarmLike>(farms: T[], token: string | null | undefined): string => {
  const farm = findFarmByIdOrName(farms, token)
  return farm?.id ? String(farm.id) : ''
}

export const resolveProductionUnitId = <U extends ProductionUnitLike>(
  farm: FarmLike<U> | undefined,
  token: string | null | undefined
): string => {
  const unit = findProductionUnitByIdOrName(farm, token)
  return unit?.id ? String(unit.id) : ''
}
